// extracted by mini-css-extract-plugin
export default {"hover":"categorical__hover___OkIZc","value":"categorical__value___gj9+U"};